// extracted by mini-css-extract-plugin
export default {"mobileMenu":"index_mobileMenu_q8icZ","handler":"index_handler_icT1Q","handlerIcon":"index_handlerIcon_kBwnt"};